import { I as IconWrapper, _ as _objectSpread2 } from '../../dist/Icon-3ba184f8.esm.js';
import 'react';
import { jsx, jsxs } from 'react/jsx-runtime';
import 'styled-components';
import '@lendi-ui/color';

function SvgAussieBot(props) {
  return /*#__PURE__*/jsx(IconWrapper, _objectSpread2(_objectSpread2({}, props), {}, {
    children: /*#__PURE__*/jsxs("svg", {
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [/*#__PURE__*/jsx("circle", {
        cx: 12,
        cy: 12,
        r: 12,
        fill: "#4B1F68"
      }), /*#__PURE__*/jsx("circle", {
        cx: 12,
        cy: 12,
        r: 12,
        fill: "#4B1F68"
      }), /*#__PURE__*/jsxs("g", {
        clipPath: "url(#aussie-bot_svg__clip0_539_34309)",
        children: [/*#__PURE__*/jsx("path", {
          d: "M18.819 12.183l.002-.002-6.241-4.933S12.3 7 12.02 7c-.266 0-.57.254-.57.254l-6.273 4.93h.003a.453.453 0 00-.18.353c0 .255.225.463.5.463H18.499c.276 0 .501-.208.501-.463a.453.453 0 00-.181-.354zM17.01 12c0 .042-.036.077-.08.077H7.08h.004-.01a.078.078 0 01-.08-.077c0-.026.017-.05.04-.063l4.784-3.76s.117-.098.206-.098c.082 0 .198.103.198.103l4.758 3.761a.072.072 0 01.031.057",
          fill: "#fff"
        }), /*#__PURE__*/jsx("path", {
          d: "M19 14.778a.228.228 0 01-.233.222H5.233c-.13 0-.233-.1-.233-.222v-.556c0-.122.104-.222.233-.222h13.534c.128 0 .233.1.233.222v.556zM19 16.778a.228.228 0 01-.233.222H5.233c-.13 0-.233-.1-.233-.222v-.555c0-.123.104-.223.233-.223h13.534c.128 0 .233.1.233.223v.555z",
          fill: "#FFD11F"
        })]
      }), /*#__PURE__*/jsx("defs", {
        children: /*#__PURE__*/jsx("clipPath", {
          id: "aussie-bot_svg__clip0_539_34309",
          children: /*#__PURE__*/jsx("path", {
            fill: "#fff",
            transform: "translate(5 7)",
            d: "M0 0h14v10H0z"
          })
        })
      })]
    })
  }));
}

export { SvgAussieBot as default };
